import { render, staticRenderFns } from "./RelatorioAgendasComHorarios.vue?vue&type=template&id=23b16ec3&"
import script from "./RelatorioAgendasComHorarios.vue?vue&type=script&lang=js&"
export * from "./RelatorioAgendasComHorarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports